var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 16,
    viewBox: "0 0 26 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.2815L2.78778 15.3799L12.6028 5.81042L23.1978 15.3799L26 12.2815L12.6172 0.191528L0 12.2815Z",
    fill: "#cccccc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpDisable);
export default __webpack_public_path__ + "static/media/up-disable.81679937cc7f5d2e2e6f9809b7eac1ae.svg";
export { ForwardRef as ReactComponent };